<template>
  <div id="Target_retrieval">
    <div class="font">
      <span class="introSubTitle"><b>大规模遥感图像智能检索系统(http://search-image.tianditu.com)</b></span
      >
      <p class="textStyle"
      >
        研发了大规模、功能丰富、支持多种地物和目标种类的遥感图像智能检索系统，支持全国300个城市37种地物或目标检索，综合运用深度学习、语义理解等新技术研发的遥感图像智能检索系统。系统支持的检索功能主要有:根据地物类型进行检索，距离约束下的地物类型检索，多种地物类型和约束下的复合检索，拉框选定对象进行检索以及上传图像进行检索等。</p
      >
    </div>
    <!-- <br/>   -->
    <div class="container">
      <my-video :sources="video.sources" :options="video.options"></my-video>
    </div>
  </div>
</template>

<script>
import myVideo from "vue-video";

export default {
  data() {
    return {
      video: {
        sources: [
          {src: require("@/assets/static/target_retrieval.mp4"), type: "video/mp4"},
        ],
        options: {
          autoplay: true,
          volume: 0.6,
        },
      },
    };
  },
  components: {
    myVideo,
  },
};
</script>

<style lang="less">
#Target_retrieval {
  margin-top: 20px;

  .font {
    // font-family: "Times New Roman", Times, serif;
    line-height: 24px;
    font-size: 14px;
    color: #454545;
  }
}
</style>
